// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import KeycloakProviderWrapper from "shared/security/KeycloakWrapperProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <KeycloakProviderWrapper>
    <App />
  </KeycloakProviderWrapper>
);